export const selectAuth = (state: any) => state.auth;
export const selectUser = (state: any) => state.auth.user;
export const selectToken = (state: any) => state.auth.token;
export const selectIsAuthenticated = (state: any) => state.auth.isAuthenticated;
export const selectAuthLoading = (state: any) => state.auth.loading;
export const selectAuthError = (state: any) => state.auth.error;
export const selectLastActivity = (state: any) => state.auth.lastActivity;
export const selectUserRole = (state: any) => state.auth.user?.role;
export const selectUserId = (state: any) => state.auth.user?.id;
export const selectUserEmail = (state: any) => state.auth.user?.email;
